var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('base-title',{class:_vm.required?'required':'',domProps:{"innerHTML":_vm._s(_vm.title)}}),(_vm.title)?_c('v-divider'):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }